import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { THEMES } from 'root-constants'
import { PageIdWoofz22V3 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ22_V3: Record<
  Exclude<PageIdWoofz22V3, PageIdWoofz22V3.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.DOG_AGE_22V3]: {
    id: PageId.DOG_AGE_22V3,
    headerId: HeaderId.TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.SEX_22V3]: {
    id: PageId.SEX_22V3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.DOG_BREED_22V3]: {
    id: PageId.DOG_BREED_22V3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.DOG_BREED_ID_22V3]: {
    id: PageId.DOG_BREED_ID_22V3,
  },
  [PageId.URGE_22V3]: {
    id: PageId.URGE_22V3,
    headerId: HeaderId.BACK_TITLE_MENU,
    theme: THEMES.URGE,
  },
  [PageId.COMMANDS_61_22V3]: {
    id: PageId.COMMANDS_61_22V3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.COMMANDS_62_22V3]: {
    id: PageId.COMMANDS_62_22V3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.COMMANDS_63_22V3]: {
    id: PageId.COMMANDS_63_22V3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.POTTY_22V3]: {
    id: PageId.POTTY_22V3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.BEHAVIOR_2_22V3]: {
    id: PageId.BEHAVIOR_2_22V3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.TRAINING_22V3]: {
    id: PageId.TRAINING_22V3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_2_22V3]: {
    id: PageId.URGE_2_22V3,
    headerId: HeaderId.BACK_TITLE_MENU,
    theme: THEMES.URGE,
  },
  [PageId.PREPARE_FLOW_22V3]: {
    id: PageId.PREPARE_FLOW_22V3,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.DOG_STATISTICS_22V3]: {
    id: PageId.DOG_STATISTICS_22V3,
    headerId: HeaderId.BACK_TITLE_MENU,
    theme: THEMES.URGE,
  },
  [PageId.EMAIL_22V3]: {
    id: PageId.EMAIL_22V3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.NEWSLETTER_URGE_22V3]: {
    id: PageId.NEWSLETTER_URGE_22V3,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.LAST_CHANCE_OFFER_22V3]: {
    id: PageId.LAST_CHANCE_OFFER_22V3,
    headerId: HeaderId.TITLE_MENU,
  },
  [PageId.SUBSCRIPTIONS_22V3]: {
    id: PageId.SUBSCRIPTIONS_22V3,
  },
  [PageId.PAYMENT_22V3]: {
    id: PageId.PAYMENT_22V3,
  },
  [PageId.LAST_CHANCE_OFFER_2_22V3]: {
    id: PageId.LAST_CHANCE_OFFER_2_22V3,
  },
  [PageId.CANCEL_OFFER_22V3]: {
    id: PageId.CANCEL_OFFER_22V3,
  },
  [PageId.CHAT_UPSELL_22V3]: {
    id: PageId.CHAT_UPSELL_22V3,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_22V3]: {
    id: PageId.UPSELL_22V3,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_FEEDING_GUIDE_22V3]: {
    id: PageId.UPSELL_FEEDING_GUIDE_22V3,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_EMOTIONAL_SUPPORT_22V3]: {
    id: PageId.UPSELL_EMOTIONAL_SUPPORT_22V3,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_PITPAT_22V3]: {
    id: PageId.UPSELL_PITPAT_22V3,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_22V3]: {
    id: PageId.DOWNLOAD_22V3,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
